import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import LanguageProvider from "containers/LanguageProvider";
import * as serviceWorker from "./serviceWorker";
import { translationMessages } from "./i18n";
import store from "./redux/store";
import App from "./App";
import "./index.css";

const MOUNT_NODE = document.getElementById("root");

const render = (messages) => {
  ReactDOM.render(
    <Provider store={store}>
      <LanguageProvider messages={messages}>
        <App />
      </LanguageProvider>
    </Provider>,
    MOUNT_NODE
  );
};

render(translationMessages);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
